import React, {useContext, useState} from 'react'
import './settings2.css'
import PhoneIcon from 'Images/agents/profile/phone-icon.svg'
import {Text} from 'ladder/ux/typography2'
import {InputField, SingleSelect} from 'ladder/agents/dashboard/inputs2'
import {EmailInput, TextInput} from 'ladder/ux/form2'
import {CheckboxSlider} from 'ladder/ux/checkbox2'
import {BackButton} from 'ladder/agents/dashboard/nav2'
import {typingPhoneFmt} from 'ladder/common2'
import {Primary} from 'ladder/ux/button2'
import {DashboardQueryContext} from 'ladder/agents/dashboard/DashboardQueryContext'

function AgentPhone({phone, setPhone, ext, setExt, label}) {
  return <div className='phone-with-ext'>
    <PhoneIcon/>
    <div className='phone input'>
      <div className='input-label'>{label}</div>
      <input className='medium-font-size'
             type='tel'
             placeholder='XXX-XXX-XXXX'
             pattern='^\\d{3}-\\d{3}-\\d{4}$'
             value={phone}
             maxLength={14}
             onChange={e => setPhone(typingPhoneFmt(e.target.value))}/>
    </div>
    <div className='ext input'>
      <div className='input-label'>Ext</div>
      <input className='medium-font-size'
             type='tel'
             placeholder='XXX'
             pattern='^\\d{3}$'
             value={ext}
             maxLength={6}
             onChange={e => setExt(e.target.value.replaceAll(/[^\d-]/g, ''))}/>
    </div>
  </div>
}


export function SettingsProfilePage2(props) {
  const {mutation, ...q} = useContext(DashboardQueryContext);
  const [fields, setFields] = useState({
    'agent/first-name': q['agent/first-name'],
    'agent/last-name': q['agent/last-name'],
    'agent/email-address': q['agent/email-address'],
    'agent/calendly-link': q['agent/calendly-link'],
    'agent/share-contact-info': q['agent/share-contact-info'],
    'agent/share-phone-number-type': q['agent/share-phone-number-type'],
    'agent/phone-number': q['agent/phone-number'],
    'agent/phone-number-extension': q['agent/phone-number-extension'],
    'agent/office-phone-number': q['agent/office-phone-number'],
    'agent/office-phone-number-extension': q['agent/office-phone-number-extension']
  })
  const [error, setError] = useState(null)
  const [justChangedEmail, setJustChangedEmail] = useState(false)

  function updateFormField(k: keyof (typeof fields), v) {
    setFields(Object.assign({}, fields, {[k]: v}))
  }

  function onError(error) {
    setError(error.response?.data?.['error-map'])
  }

  function onSuccess(result) {
    setError(null)
    if (result.data?.['updated-email']) {
      setJustChangedEmail(true)
    }
  }

  function onClickSaveChanges() {
    const changedFields = {}
    for (const k in fields) {
      if (fields[k] !== q[k]) {
        changedFields[k] = fields[k]
      }
    }
    const mutationData = {def: 'agent-dash/save-profile-edits', params: changedFields}
    mutation.mutate(mutationData, {onError, onSuccess})
  }

  const sharedInputProps = {
    textSize: '13', textWeight: 'medium', floatingPlaceholder: true, removeBorder: true,
  }

  return <div className='agent-settings-profile-page'>
    <BackButton onClick={() => props.onNavigate('settings')}/>
    <div className='container'>
      <Text block size='header-40' weight='300' style={{alignSelf: 'start'}}>Profile</Text>
      <br/>
      <Text block size='body-15' lineHeight='30px'>
        Enter your info here. We’ll share with clients when they visit your personalized homepage.</Text>
      <div className='form'>
        <div className='share-contact-slider-container'>
          <Text size='body-15'>Share contact info</Text>
          <CheckboxSlider onChange={x => updateFormField('agent/share-contact-info', x)}
                          checked={fields['agent/share-contact-info']}/>
        </div>
        {fields['agent/share-contact-info'] && <div className='share-phone-number-type'>
          <Text size='body-15' lineHeight='30px'>Which phone number would you like to share publicly with
            clients?</Text>
          <SingleSelect
              onChange={x => updateFormField('agent/share-phone-number-type', x)}
              value={fields['agent/share-phone-number-type']}
              options={[{'option-value': 'mobile', 'option-label': 'Mobile', emoji: '📱️'}, {
                'option-value': 'office', 'option-label': 'Office', emoji: '☎️',
              }]}/>
        </div>}
        <InputField svgPath='agents/profile/first-name-icon'
                    inputDom={<TextInput {...sharedInputProps}
                                         value={fields['agent/first-name']}
                                         placeholder='First name'
                                         onChange={x => updateFormField('agent/first-name', x)}/>}/>
        <InputField svgPath='agents/profile/last-name-icon'
                    inputDom={<TextInput {...sharedInputProps}
                                         value={fields['agent/last-name']}
                                         placeholder='Last name'
                                         onChange={x => updateFormField('agent/last-name', x)}/>}/>
        <InputField svgPath='agents/profile/agency-icon'
                    inputDom={<TextInput {...sharedInputProps}
                                         value={q['agent/agency-name']}
                                         placeholder='Agency'
                                         disabled
                                         onChange={() => null}/>}/>
        <InputField svgPath='agents/profile/professional-email-icon'
                    inputDom={<EmailInput {...sharedInputProps}
                                          value={fields['agent/email-address']}
                                          placeholder='Email'
                                          onChange={x => updateFormField('agent/email-address', x)}/>}/>
        <AgentPhone label='Mobile'
                    phone={fields['agent/phone-number']}
                    setPhone={x => updateFormField('agent/phone-number', x)}
                    ext={fields['agent/phone-number-extension']}
                    setExt={x => updateFormField('agent/phone-number-extension', x)}/>
        <AgentPhone label='Office'
                    phone={fields['agent/office-phone-number']}
                    setPhone={x => updateFormField('agent/office-phone-number', x)}
                    ext={fields['agent/office-phone-number-extension']}
                    setExt={x => updateFormField('agent/office-phone-number-extension', x)}/>
        <InputField svgPath='agents/profile/calendar-icon'
                    inputDom={<EmailInput {...sharedInputProps}
                                          value={fields['agent/calendly-link']}
                                          placeholder='Calendly scheduling link (optional)'
                                          onChange={x => updateFormField('agent/calendly-link', x)}/>}/>
        {!!error && Object.entries(error).map(([field, errMsg]: [string, string]) => (
            <Text block color='red' key={field}>{errMsg}</Text>))}
        <div className='save-changes-button'>
          <Primary onClick={onClickSaveChanges}
                   name='save-changes'
                   backgroundColor='#336FED'
                   fullWidth
                   loading={mutation.isPending}
                   roundedCorners>
            Save changes
          </Primary>
        </div>
        {justChangedEmail && <Text className='updated-email-reminder-text'>
          To confirm your email address change, please click the link sent to your old email.
        </Text>}
      </div>
    </div>
  </div>
}

export function SettingsSupportPage2({onNavigate}) {
  return <div className='agent-settings-support-page'>
    <BackButton onClick={() => onNavigate('settings')}/>
    <Text block size='header-40' weight='300' className='heading'>Support</Text>
    <Text block size='header-20' lineHeight='35px' className='subheading'>We’re here to help</Text>
    <Text block size='body-15' lineHeight='30px'>Our licensed support team is here to assist with any questions you may
      have.</Text>
    <div className='schedule-call-button'>
      <a href='https://calendly.com/d/y42-q4n-3tq/agent-support'>
        <Primary onClick={() => null} name='schedule-call' backgroundColor='#336FED' fullWidth roundedCorners>
          Schedule a call
        </Primary>
      </a>
    </div>
  </div>

}
